export enum TvPlatform{
    Generic = "TV",
    AndroidTv = "AndroidTv",
    Roku = "Roku",
    SamsungTv = "SamsungTv",
    FireStick = "Firestick"
}